import { render, staticRenderFns } from "./PalletFilterBar.vue?vue&type=template&id=24257562"
import script from "./PalletFilterBar.vue?vue&type=script&lang=js"
export * from "./PalletFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports